<template>
  <div class="text-center">
    <h1>Acerca de</h1>
      <p class="text-center">SAED Digital <br /> {{ new Date() | moment("DD-MM-YYYY")}} <br /> v{{this.appversion}} </p>
      <a href="#" onClick="window.location.reload(true)">Actualizar</a>
  </div>
</template>
<script>

export default {
  computed: {
    appversion: function(){
      return process.env.VUE_APP_VERSION;
    },
  },

};
</script>